import React, { useMemo, useState } from 'react'
import AppContext from './Context'

// eslint-disable-next-line react/prop-types
export default function AppProvider ({ children }) {
  const [usedStyles, setUsedStyles] = useState({ filter: 'blur(0px)' })
  const [items, setItems] = useState([])
  const [user, setUser] = useState('')
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)
  const [filter, setFilter] = useState('destaque=1')
  const [product, setProduct] = useState('')
  const [editMode, setEditMode] = useState(false)
  const data = useMemo(
    () => ({
      usedStyles,
      setUsedStyles,
      items,
      setItems,
      user,
      setUser,
      filter,
      setFilter,
      loading,
      setLoading,
      error,
      setError,
      product,
      setProduct,
      editMode,
      setEditMode
    }), [
      usedStyles,
      setUsedStyles,
      items,
      setItems,
      user,
      setUser,
      filter,
      setFilter,
      loading,
      setLoading,
      error,
      setError,
      product,
      setProduct,
      editMode,
      setEditMode
    ]
  )
  return (
    <AppContext.Provider value ={data}>
      {children}
    </AppContext.Provider>
  )
}
